var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.707 9.293a1 1 0 0 1-1.414 0L1.707 6.707C1.077 6.077 1.523 5 2.414 5h5.172c.89 0 1.337 1.077.707 1.707L5.707 9.293Z",
    fill: "var(--native-icon-fill)"
  })));
};

export default SvgDropdown;